import { TReduxActions } from '../../types/redux/actions';
import { ILegalCheckInfo } from '../../types/legalCheckInfo';
import { ELegalCheckInfoActions } from '../../constants/actionTypes/legalCheckInfo';
import { IStepSchema } from '../../repositories/legal-check/entities/step/StepSchema';

export const defaultState: ILegalCheckInfo = {
  demoReportLink: '',
  firstStep: {} as IStepSchema,
  priceText: '',
  faq: [],
};

export function legalCheckInfoReducer(state: ILegalCheckInfo = defaultState, action: TReduxActions) {
  switch (action.type) {
    case ELegalCheckInfoActions.setLegalCheckInfo:
      return {
        ...action.payload,
      };

    default:
      return state;
  }
}
